const BaseModel = require('./BaseModel');
const HTTPClient = require('../HTTPClient');

class FlowInstanceQuestion extends BaseModel {
  static basePath = '/api/v1/flow-instances/:flowInstanceId/questions';
  static dataType = 'flow-instance-question';

  static basePathFor(flowInstanceId) {
    return(this.basePath.replace(':flowInstanceId', flowInstanceId));
  }

  static list(flowInstanceId, args = {}) {
    return(BaseModel.list({ ...args, path: this.basePathFor(flowInstanceId) }));
  }

  static current(flowInstanceId, { filters = null } = {}) {
    let path = `${this.basePathFor(flowInstanceId)}/current`;
    let params = [];

    if (filters != null) {
      params.push(...this._nestedParamBuilder(filters, 'filter'))
    }

    if (params.length > 0) {
      path = `${path}?${params.join('&')}`;
    }

    return new HTTPClient().get(path).then(this.prototype.constructor._parseDataItem.bind(this));
  }

  static states(flowInstanceId) {
    let path = `${this.basePathFor(flowInstanceId)}/states`;

    return new HTTPClient().get(path).then(this.prototype.constructor._parseDataItemArray.bind(this));
  }

  static submitAnswer(flowInstanceId, questionId, value) {
    let path = `${this.basePathFor(flowInstanceId)}/${questionId}`;
    let body = { value };

    if(value instanceof File) {
      body = new FormData();
      body.append('value', value);
    }

    return new HTTPClient().put(path, body).then(this.prototype.constructor._parseDataItem.bind(this));
  }
}

BaseModel.models[FlowInstanceQuestion.dataType] = FlowInstanceQuestion;
module.exports = FlowInstanceQuestion;
